<div class="widget">
    <ins class="bookingaff" data-aid="2143450" data-target_aid="2143450" data-prod="map" data-width="100%" data-height="590" data-lang="de" data-currency="EUR" data-dest_id="0" data-dest_type="landmark" data-latitude="47.8708161" data-longitude="13.5480642" data-mwhsb="0" data-address="Attersee, Austria" data-zoom="11">
        <!-- Anything inside will go away once widget is loaded. -->
            <a href="//www.booking.com?aid=2143450">Booking.com</a>
    </ins>
</div>
